import http from "./http";

export function articleDetail(articleId) {
    return http.get(`/api/weChat/applet/article/detail/${articleId}`);
}


export function listArticle(params = {}, pageNum = 1, pageSize = 6) {
    let url = `/api/weChat/applet/article/list?pageNum=${pageNum}&pageSize=${pageSize}`;
    return http.post(url, params)
}
